<template>
  <div class="models_wrap">
    <h4>模型配置</h4>
    <div class="toolbar">
      <el-form :inline="true" :model="queryForm" class="query_form">
        <el-form-item label="名称">
          <el-input v-model="queryForm.name" placeholder="名称模糊搜索" clearable
                    style="width: 180px" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="提供商">
          <el-select v-model="queryForm.provider" placeholder="全部" clearable style="width: 120px">
            <el-option label="OpenAI 兼容" value="openai" />
            <el-option label="Ollama" value="ollama" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button type="primary" icon="el-icon-plus" @click="openAdd">新增配置</el-button>
    </div>

    <el-table :data="tableData" v-loading="loading" border>
      <el-table-column prop="name" label="配置名" min-width="130" show-overflow-tooltip />
      <el-table-column label="提供商" width="110">
        <template slot-scope="scope">
          <el-tag size="small" :type="scope.row.provider === 'ollama' ? 'warning' : ''">
            {{ scope.row.provider === 'ollama' ? 'Ollama' : 'OpenAI 兼容' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="chat_model" label="对话模型" min-width="130" show-overflow-tooltip />
      <el-table-column label="密钥" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.api_key || '（无）' }}</template>
      </el-table-column>
      <el-table-column label="温度" width="70" align="center">
        <template slot-scope="scope">{{ scope.row.temperature === undefined || scope.row.temperature === null ? '默认' : scope.row.temperature }}</template>
      </el-table-column>
      <el-table-column label="默认" width="70" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_default" type="success" size="small">默认</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="160">
        <template slot-scope="scope">{{ fmtTime(scope.row.utime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="130" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" class="danger_text" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagesize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <h4 class="bind_title">角色绑定（数字员工按角色使用模型配置）</h4>
    <div class="toolbar">
      <span class="bind_tip">同一数字员工的同一角色仅一个生效配置；未绑定的角色回退默认配置。</span>
      <el-button type="primary" icon="el-icon-plus" size="small" @click="openBind">添加绑定</el-button>
    </div>
    <el-table :data="bindings" v-loading="bindLoading" border size="small">
      <el-table-column label="数字员工" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">{{ agentName(scope.row.agent_id) }}</template>
      </el-table-column>
      <el-table-column label="角色" width="110">
        <template slot-scope="scope">{{ ROLE_TEXT[scope.row.role] || scope.row.role }}</template>
      </el-table-column>
      <el-table-column label="模型配置" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">{{ configName(scope.row.config_id) }}</template>
      </el-table-column>
      <el-table-column label="绑定时间" width="160">
        <template slot-scope="scope">{{ fmtTime(scope.row.ctime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="80" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" class="danger_text" @click="delBind(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑配置 -->
    <el-dialog :title="isEdit ? '编辑模型配置' : '新增模型配置'" :visible.sync="dlgVisible" width="620px" v-dialogDrag
               :modal-append-to-body="false" v-if="dlgVisible">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="配置名" prop="name">
          <el-input v-model="form.name" maxlength="64" placeholder="同账号下唯一" />
        </el-form-item>
        <el-form-item label="提供商" prop="provider">
          <el-radio-group v-model="form.provider">
            <el-radio label="openai">OpenAI 兼容</el-radio>
            <el-radio label="ollama">Ollama</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Base URL" prop="base_url">
          <el-input v-model="form.base_url" placeholder="如 http://host:port/v1" />
        </el-form-item>
        <el-form-item label="API Key" prop="api_key">
          <el-input v-model="form.api_key" :placeholder="isEdit ? '不修改则保留原密钥（留空或含 * 均视为不变）' : (form.provider === 'openai' ? '必填' : 'Ollama 通常留空')" />
        </el-form-item>
        <el-form-item label="对话模型" prop="chat_model">
          <el-input v-model="form.chat_model" maxlength="128" placeholder="模型标识，如 gpt-4o / qwen3:9b" />
        </el-form-item>
        <el-form-item label="Embedding URL">
          <el-input v-model="form.embedding_url" placeholder="留空则复用 Base URL" />
        </el-form-item>
        <el-form-item label="Embedding Key">
          <el-input v-model="form.embedding_api_key" placeholder="不修改则保留原密钥" />
        </el-form-item>
        <el-form-item label="Embedding 模型">
          <el-input v-model="form.embedding_model" maxlength="128" placeholder="留空则用对话模型" />
        </el-form-item>
        <el-form-item label="温度 temperature">
          <el-input-number v-model="form.temperature" :min="0" :max="2" :step="0.1" :precision="1"
                           placeholder="留空使用服务端默认" controls-position="right" style="width: 180px" />
          <span class="form_tip">0~2；留空 = 保留原值/默认</span>
        </el-form-item>
        <el-form-item label="思考处理">
          <el-switch v-model="form.remove_think" active-text="剥离思考" style="margin-right: 12px" />
          <el-switch v-model="form.disable_think" active-text="关闭思考生成" />
        </el-form-item>
        <el-form-item label="设为默认">
          <el-switch v-model="form.is_default" active-text="默认配置（同账号唯一）" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dlgVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submiting" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加角色绑定 -->
    <el-dialog title="添加角色绑定" :visible.sync="bindVisible" width="480px" v-dialogDrag
               :modal-append-to-body="false" v-if="bindVisible">
      <el-form ref="bindForm" :model="bindForm" :rules="bindRules" label-width="90px">
        <el-form-item label="数字员工" prop="agent_id">
          <el-select v-model="bindForm.agent_id" placeholder="选择数字员工" style="width: 100%">
            <el-option v-for="a in agentOpts" :key="a.agent_id" :label="a.display_name || a.name" :value="a.agent_id" />
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="bindForm.role" style="width: 100%">
            <el-option v-for="(text, key) in ROLE_TEXT" :key="key" :label="text" :value="key" />
          </el-select>
        </el-form-item>
        <el-form-item label="模型配置" prop="config_id">
          <el-select v-model="bindForm.config_id" placeholder="选择配置" style="width: 100%">
            <el-option v-for="c in configOpts" :key="c.config_id" :label="c.name + '（' + c.chat_model + '）'" :value="c.config_id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="bindVisible = false">取 消</el-button>
        <el-button type="primary" :loading="bindSaving" @click="submitBind">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { agentBody, isEnterprise } from '../utils'

const ROLE_TEXT = {
  default: '默认',
  router: '路由',
  step: '步骤执行',
  response: '最终回复',
  general_skill: '通用技能',
  turn_planner: '轮次规划',
  summarizer: '摘要'
}

// 模型配置与角色绑定（仅企业可见，写操作后端校验企业身份）
export default {
  name: 'AiAgentModels',
  data() {
    const keyValidator = (rule, value, callback) => {
      if (this.form.provider === 'openai' && !(value || '').trim()) callback(new Error('OpenAI 兼容模式下 API Key 必填'))
      else callback()
    }
    return {
      ROLE_TEXT,
      queryForm: { name: '', provider: '' },
      tableData: [],
      loading: false,
      currentPage: 1,
      pagesize: 20,
      total: 0,
      reqSeq: 0,
      loaded: false,
      dlgVisible: false,
      isEdit: false,
      submiting: false,
      form: this.emptyForm(),
      rules: {
        name: [{ required: true, message: '请输入配置名', trigger: 'blur' }],
        base_url: [{ required: true, message: '请输入 Base URL', trigger: 'blur' }],
        chat_model: [{ required: true, message: '请输入对话模型', trigger: 'blur' }],
        api_key: [{ validator: keyValidator, trigger: 'blur' }]
      },
      bindings: [],
      bindLoading: false,
      agentOpts: [], configOpts: [],
      bindVisible: false,
      bindSaving: false,
      bindForm: { agent_id: '', role: 'default', config_id: '' },
      bindRules: {
        agent_id: [{ required: true, message: '请选择数字员工', trigger: 'change' }],
        config_id: [{ required: true, message: '请选择模型配置', trigger: 'change' }]
      }
    }
  },
  methods: {
    emptyForm() {
      return {
        config_id: '', name: '', provider: 'openai', base_url: '', api_key: '', chat_model: '',
        embedding_url: '', embedding_api_key: '', embedding_model: '',
        remove_think: false, disable_think: false, temperature: undefined, is_default: false
      }
    },
    onActivate() {
      if (!this.loaded) this.loadList()
    },
    loadList() {
      this.loading = true
      const seq = ++this.reqSeq
      const data = { page: this.currentPage, limit: this.pagesize }
      if (this.queryForm.name) data.name = this.queryForm.name
      if (this.queryForm.provider) data.provider = this.queryForm.provider
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentModelsConfigList, agentBody(data)).then((res) => {
        if (seq !== this.reqSeq) return
        if (res.data.code == 0) {
          this.tableData = res.data.data.data || []
          this.total = res.data.data.total || 0
          this.loaded = true
        }
        this.loading = false
      }).catch(() => { if (seq === this.reqSeq) this.loading = false })
    },
    onSearch() { this.currentPage = 1; this.loadList() },
    resetQuery() { this.queryForm = { name: '', provider: '' }; this.onSearch() },
    handleSizeChange(val) { this.pagesize = val; this.loadList() },
    handleCurrentChange(val) { this.currentPage = val; this.loadList() },
    fmtTime(s) {
      if (!s) return '-'
      return this.$tools.parserDateTime('datetime', s) || s.substring(0, 19).replace('T', ' ')
    },

    /* ---------- 配置 CRUD ---------- */
    openAdd() {
      this.form = this.emptyForm()
      this.isEdit = false
      this.dlgVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    // edit 为全量覆盖语义：行数据（含掩码 key）完整落表单，提交时全字段回传；掩码串原样回传 = 保留原密钥
    openEdit(row) {
      this.form = { ...this.emptyForm(), ...row }
      this.isEdit = true
      this.dlgVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    buildPayload() {
      return {
        config_id: this.form.config_id,
        name: this.form.name,
        provider: this.form.provider,
        base_url: this.form.base_url,
        api_key: this.form.api_key || '',
        chat_model: this.form.chat_model,
        embedding_url: this.form.embedding_url || '',
        embedding_api_key: this.form.embedding_api_key || '',
        embedding_model: this.form.embedding_model || '',
        remove_think: !!this.form.remove_think,
        disable_think: !!this.form.disable_think,
        // null = 保留服务端旧值（显式 0 是合法值会覆盖）
        temperature: (this.form.temperature === undefined || this.form.temperature === null) ? null : Number(this.form.temperature),
        is_default: !!this.form.is_default
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submiting = true
        const payload = this.buildPayload()
        let url = this.$baseUrl.aiAgentModelsConfigAdd
        if (this.isEdit) url = this.$baseUrl.aiAgentModelsConfigEdit
        else delete payload.config_id
        this.$tools.asyncPost(this, url, agentBody(payload)).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '保存成功' })
            this.dlgVisible = false
            this.loadList()
            this.configOpts = [] // 配置集合已变，绑定下拉下次重拉
          }
          this.submiting = false
        }).catch((err) => {
          this.submiting = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
        })
      })
    },
    handleDel(row) {
      this.$MessageBox.confirm('删除后不可恢复；若已被角色绑定引用将无法删除。确认删除该配置？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentModelsConfigDel,
          agentBody({ config_id: row.config_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.tableData.length === 1 && this.currentPage > 1) this.currentPage -= 1
            this.loadList()
            this.configOpts = []
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
        })
      }).catch(() => {})
    },

    /* ---------- 角色绑定 ---------- */
    loadBindings() {
      this.bindLoading = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentModelsBindingList,
        agentBody({ page: 1, limit: 0 })).then((res) => {
        if (res.data.code == 0) this.bindings = res.data.data.data || []
        this.bindLoading = false
      }).catch(() => { this.bindLoading = false })
    },
    ensureOpts() {
      if (!this.agentOpts.length) {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentAgentsList,
          agentBody({ page: 1, limit: 0 })).then((res) => {
          if (res.data.code == 0) this.agentOpts = res.data.data.data || []
        }).catch(() => {})
      }
      if (!this.configOpts.length) {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentModelsConfigList,
          agentBody({ page: 1, limit: 0 })).then((res) => {
          if (res.data.code == 0) this.configOpts = res.data.data.data || []
        }).catch(() => {})
      }
    },
    agentName(id) {
      const a = this.agentOpts.find(x => x.agent_id === id)
      return a ? (a.display_name || a.name) : id
    },
    configName(id) {
      const c = this.configOpts.find(x => x.config_id === id)
      return c ? c.name : id
    },
    openBind() {
      this.bindForm = { agent_id: '', role: 'default', config_id: '' }
      this.bindVisible = true
      this.ensureOpts()
      this.$nextTick(() => this.$refs.bindForm && this.$refs.bindForm.clearValidate())
    },
    submitBind() {
      this.$refs.bindForm.validate((valid) => {
        if (!valid) return
        this.bindSaving = true
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentModelsBindingAdd,
          agentBody({ agent_id: this.bindForm.agent_id, role: this.bindForm.role, config_id: this.bindForm.config_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '绑定成功' })
            this.bindVisible = false
            this.loadBindings()
          }
          this.bindSaving = false
        }).catch((err) => {
          this.bindSaving = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
        })
      })
    },
    delBind(row) {
      this.$MessageBox.confirm('确认删除该角色绑定？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentModelsBindingDel,
          agentBody({ binding_id: row.binding_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '已删除' })
            this.loadBindings()
          }
        }).catch(() => {})
      }).catch(() => {})
    }
  },
  mounted() {
    // 模型 Tab 仅企业可见；其他账号常驻挂载下发请求会弹错，跳过自动加载
    if (!isEnterprise()) return
    this.loadList()
    this.loadBindings()
    this.ensureOpts()
  }
}
</script>

<style lang="less" scoped>
h4 { font-size: 14px; margin: 0 0 10px; }
.bind_title { margin-top: 24px; }
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // 表单下边距改由 toolbar 承担，保证表格前的间距不变
  margin-bottom: 22px;
  .query_form {
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }
}
.bind_tip { font-size: 12px; color: #909399; line-height: 32px; }
.form_tip { font-size: 12px; color: #909399; margin-left: 8px; }
.danger_text { color: #f56c6c; }
</style>
